'use client';

import ChevronLeftIcon from '@/shared/assets/chevron-left.svg?svg';
import { Button } from '@/shared/ui';
import { useRouter } from 'next/navigation';

import styles from './BackButton.module.css';

interface BackButtonProps {
  fallback?: string;
}

export const BackButton = ({ fallback = '/' }: BackButtonProps) => {
  const router = useRouter();

  const onClick = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push(fallback);
    }
  };

  return (
    <Button className={styles.backBtn} onClick={onClick}>
      <ChevronLeftIcon />
      Назад
    </Button>
  );
};
